"use strict";
/**
 * @packageDocumentation
 * @module DID
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = exports.remove = exports.queryByAddress = exports.queryByIdentifier = void 0;
const chain_helpers_1 = require("@kiltprotocol/chain-helpers");
const Did_utils_1 = require("./Did.utils");
/**
 * @param identifier
 * @internal
 */
async function queryByIdentifier(identifier) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const address = Did_utils_1.getAddressFromIdentifier(identifier);
    const decoded = Did_utils_1.decodeDid(identifier, await blockchain.api.query.did.dIDs(address));
    return decoded;
}
exports.queryByIdentifier = queryByIdentifier;
/**
 * @param address
 * @internal
 */
async function queryByAddress(address) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const identifier = Did_utils_1.getIdentifierFromAddress(address);
    const decoded = Did_utils_1.decodeDid(identifier, await blockchain.api.query.did.dIDs(address));
    return decoded;
}
exports.queryByAddress = queryByAddress;
/**
 * @internal
 */
async function remove() {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const tx = blockchain.api.tx.did.remove();
    return tx;
}
exports.remove = remove;
/**
 * @param did
 * @internal
 */
async function store(did) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const tx = blockchain.api.tx.did.add(did.publicBoxKey, did.publicSigningKey, did.documentStore);
    return tx;
}
exports.store = store;
